import api from '@/lib/api';

export interface Note {
  id: string;
  ticket_id: string;
  title: string;
  content: string;
  author_id: string;
  parent_comment_id: string | null;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  author_name?: string;
  author_email?: string;
  ticket_number?: string;
  ticket_subject?: string;
  comment_created_at?: string;
  attachment_count?: number;
  attachments?: any[];
  attachments_url?: string;
  hasAttachments?: boolean;
  attachmentCount?: number;
  attachmentsUrl?: string;
  is_agent?: boolean;
}

export interface CreateNoteData {
  ticket_id: string;
  title: string;
  content: string;
  parent_comment_id?: string | null;
  attachment_ids?: string[];
  is_agent?: boolean;
}

export interface UpdateNoteData {
  title?: string;
  content?: string;
}

export interface NotesListResponse {
  success: boolean;
  data: {
    ticket: {
      id: string;
      ticket_number: string;
      subject: string;
    };
    notes: Note[];
    stats: {
      totalNotes: number;
      uniqueAuthors: number;
      avgContentLength: number;
      lastUpdate: string;
    };
  };
}

export interface CreateNoteResponse {
  success: boolean;
  message: string;
  data: {
    note: Note;
  };
}

export interface UpdateNoteResponse {
  success: boolean;
  message: string;
  data: {
    note: Note;
  };
}

export interface DeleteNoteResponse {
  success: boolean;
  message: string;
}

class NotesService {
  async getNotesByTicket(ticketId: string): Promise<NotesListResponse> {
    try {
      const response = await api.get<NotesListResponse>(`/notes/ticket/${ticketId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching notes:', error);
      throw error;
    }
  }

  async createNote(data: CreateNoteData): Promise<CreateNoteResponse> {
    try {
      const response = await api.post<CreateNoteResponse>('/notes', data);
      return response.data;
    } catch (error) {
      console.error('Error creating note:', error);
      throw error;
    }
  }

  async updateNote(id: string, data: UpdateNoteData): Promise<UpdateNoteResponse> {
    try {
      const response = await api.put<UpdateNoteResponse>(`/notes/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating note:', error);
      throw error;
    }
  }

  async deleteNote(id: string): Promise<DeleteNoteResponse> {
    try {
      const response = await api.delete<DeleteNoteResponse>(`/notes/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting note:', error);
      throw error;
    }
  }

  async searchNotes(params: {
    q?: string;
    ticket_id?: string;
    author_id?: string;
    page?: number;
    limit?: number;
  }) {
    try {
      const queryParams = new URLSearchParams();
      
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          queryParams.append(key, String(value));
        }
      });

      const response = await api.get(`/notes/search?${queryParams}`);
      return response.data;
    } catch (error) {
      console.error('Error searching notes:', error);
      throw error;
    }
  }
}

export default new NotesService();